<div class="request-wrapper" [class.is-highlighted]="state.sharingRequested || state.contactDataShared || unreadMessages > 0">
    <a [class.action-required]="state.isActionRequired" [class.unread]="unreadMessages > 0" [routerLink]="['/marketplace', member.id]" class="container">
        <header class="header">
            <h3 class="heading" [class.heading--unread]="unreadMessages > 0">{{ member.firstName }} {{ member.lastName }}</h3>
            <app-employment-state #state [relation]="memberRelation.relation"
                                  [unreadMessages]="unreadMessages"></app-employment-state>
        </header>
        @if (member.lastSeenOn) {
            <div class="last-online">
                <span class="last-online__dot" [class.last-online__dot--active]="isOnlineToday"></span>
                {{ member.lastSeenOn | relativeTime }}
            </div>
        }
        <figure aria-hidden="true" class="avatar">
            @if (member.profilePicture) {
                <img [src]="member.profilePicture.path" alt="">
            }
        </figure>
        @if (member.phoneNumber || member.emailAddress) {
            <div class="job-request-contacts">
                @if (member.phoneNumber) {
                    <span class="job-request-contact">
                        <span class="sr-only" i18n="sr-only@@employment.teamMember.telefon">Telefon:</span>
                        <a href="tel:{{ member.phoneNumber }}" (click)="$event.stopPropagation()">
                            <span class="icon icon-phone"></span>
                            {{ member.phoneNumber }}
                        </a>
                    </span>
                }
                @if (member.emailAddress) {
                    <span class="job-request-contact">
                        <span class="sr-only" i18n="sr-only@@employment.teamMember.email">E-Mail:</span>
                        <a href="mailto:{{ member.emailAddress }}" (click)="$event.stopPropagation()">
                            <span class="icon icon-mail"></span>
                            {{ member.emailAddress }}
                        </a>
                    </span>
                }
            </div>
        }
        <div>
            <span class="sr-only" i18n="sr-only@@employment.jobRequest.assistanceServices">Assistenzdienstleistungen:</span>
            <app-tag-list [tags]="offer?.assistanceServices ?? []"></app-tag-list>
        </div>
    </a>
    <button (click)="removeRequest($event)"
            class="delete-button"
            [attr.aria-label]="'Anfrage von ' + member.firstName + ' entfernen'"
            i18n-aria-label="@@employment.jobRequest.removeAriaLabel">
        <span class="icon icon-trash-2"></span>
    </button>
</div>
